import { Box, Container, Grid } from "@mui/material";
import ServiceCard from "../UI/ServiceCard";
import SectionTitle from "../UI/SectionTitle";

const SERVICES = [
  {
    id: 1,
    title: "Full Logistics Management",
    description:
      "We handle all shipping and logistics from start to finish. Every shipment is fully insured—at no extra cost—and you receive payment promptly after inspection.",
    image:
      "https://images.unsplash.com/photo-1586201375761-83865001e021?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: 2,
    title: "Accounting, Finance & Payment Management",
    description:
      "Our team generates detailed earnings reports, tax documents, and any financial summaries you need—completely free of charge.",
    image:
      "https://images.unsplash.com/photo-1601233743549-15706a1271c7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: 3,
    title: "Automated Tracking & Fast Payments",
    description:
      "Stay informed with real-time updates on your item inspections and carrier status. Get paid quickly and securely via PayPal or ACH.",
    image:
      "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: 4,
    title: "Industry-Leading Pricing & Payouts",
    description:
      "We offer the most competitive quotes. If you find a better offer elsewhere, we’ll match it—or even beat the average payouts of platforms like eBay.",
    image:
      "https://images.unsplash.com/photo-1580518322910-7c0e2eeb8c76?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80",
  },
];

export default function Services() {
  return (
    <Box sx={{ py: 8, bgcolor: "black" }}>
      <Container>
        <SectionTitle
          title="Our Services"
          subtitle="Comprehensive solutions designed to maximize your earnings and streamline operations."
        />
        <Grid container spacing={4}>
          {SERVICES.map((service) => (
            <Grid item xs={12} sm={6} md={3} key={service.id}>
              <ServiceCard {...service} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
